import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import gamblerGame from "./gamblerGame";
import { gamblerEndInterface, gamblerStartInterface } from "./gamblerGameConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class gamblerGameObj extends cc.Component {

    @property({type:cc.Node,displayName:"显示的图片"})
    showSp:cc.Node = null;

    @property({type:cc.Node,displayName:"价格的标"})
    priceNode:cc.Node = null;

    @property({type:cc.Node,displayName:"物品图片"})
    objSp:cc.Node = null;

    @property({type:cc.Node,displayName:"物品后面的光"})
    sprGoodsLight:cc.Node = null;

    startData:gamblerStartInterface = null;

    endData:gamblerEndInterface = null;

    gameScript:gamblerGame = null;

    canClick:boolean = true;

    isHaveBiao:boolean = false;

    initPos:cc.Vec2 = null;

    goodsId: number = null;

    onLoad(){
        this.node.on("touchend",this.onBtnClick,this);
    }

    start(): void {
        this.objSp.active = false;
        this.sprGoodsLight.active = false;
        this.initPos = this.node.getPosition().clone();    
    }

    bindDate(startData:gamblerStartInterface,endData:gamblerEndInterface,gameScript:gamblerGame,isHaveBiao:boolean){
        this.isHaveBiao = isHaveBiao;
        this.startData = startData;
        this.endData = endData;
        this.gameScript = gameScript;
        this.loadIcon();
        this.updatePrice();
        this.openCut();
    }

    loadIcon(){
        let iconPath = this.startData.icon;
        if(iconPath){
            // 加载icon
            getOneBundleByInstant(BUNDLE_SMALL_NAME.gamblerGameBundle).load(`gamblerGameUi/startIcon/${iconPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载图片失败")
                    return;
                }
                this.showSp.getComponent(cc.Sprite).spriteFrame = asset;
                this.scheduleOnce(()=>{
                    this.node.width = this.showSp.width;
                    this.node.height = this.showSp.height;
                });
                // this.node.width = asset.getTexture().width;
                // this.node.height = asset.getTexture().height;
            });
        }
    }

    updatePrice(){
        if(!this.canClick){
            this.priceNode.active = this.canClick;
            return;
        }
        this.priceNode.active = this.isHaveBiao;
        let priceLb:cc.Label = this.priceNode.getChildByName("label").getComponent(cc.Label);
        priceLb.string = data_control.getNumberFormat(this.startData.price);
    }

    //加载切开之后的icon
    loadEndIcon(){
        let iconPath = this.startData.icon;
        if(iconPath){
            this.showGoods();
            // 加载icon
            getOneBundleByInstant(BUNDLE_SMALL_NAME.gamblerGameBundle).load(`gamblerGameUi/cutIcon/${iconPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载图片失败")
                    return;
                }
                this.showSp.getComponent(cc.Sprite).spriteFrame = asset;
            });
        }
    }
    
    //开始木屑动画
    startSawdustAni(){
        
    }
    
    //停掉木屑动画
    stopSawdustAni(){
        
    }

    onBtnClick(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.canClick){

            let needCoin :number = this.startData.price
            if(O1HD.getServices().userSrv.getCoins() < needCoin){
                O1HD.getModules().uiControlModule.showMessageBox("金额不足");
                return;
            }else{
                O1HD.getModules().uiControlModule.showMessageBox("购买成功");
                O1HD.getServices().userSrv.setCoins(-needCoin,true);
            }
            this.gameScript.startCutObj(this.node);
            // O1HD.getManagers().soundMgr.playSound("anNiu");
            // this.gameScript.startExplain(this.node);
        }
    }
    
    openCut() {
        if (!this.endData.param) {
            return;
        }
        let backAry = this.endData.param["backpackId"];
        if(!backAry){ 
            return;
        }
        let weightAry:number[] = [];
        for(let i =0;i<backAry.length;i++){
            let back = backAry[i];
            let weight:number = back.weight;
            weightAry.push(weight);
        }
        this.goodsId = null;
        let randIndex:number = data_control.getRandIPosByWeights(weightAry);
        if(!isNaN(randIndex)){
            let back = backAry[randIndex];
            if (back && back.backpackId) {
                this.goodsId = back.backpackId
            }
        }
    }

    async showGoods() {
        if (!this.goodsId) {
            return;
        }

        let backConfig = backPackEventMap()[this.goodsId];
        // console.log(backConfig,"背包config",backAry[back],backAry[back]?.backpackId,weightAry,backAry,randIndex);
        if(backConfig){
            let objPath:string = backConfig.spPath;
            this.sprGoodsLight.active = true;
            let iconPath = "backpackAssets/objSp/" + objPath;
            let bundlePb = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
            bundlePb.load(iconPath, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        this.objSp.getComponent(cc.Sprite).spriteFrame = imgs;
                        this.objSp.active = true;
                    }
                }
            );
        }
    }
    

}
